export default function Difference() {
  const features = [
    {
      icon: 'ri-smartphone-line',
      title: 'Fully Mobile Service',
      description: 'We bring our professional equipment and premium products directly to your location—home, office, or anywhere convenient for you.'
    },
    {
      icon: 'ri-star-line',
      title: 'Meticulous Attention to Detail',
      description: 'Every inch of your vehicle receives expert care. We focus on the details that matter, ensuring a flawless finish inside and out.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Protecting Your Investment',
      description: 'Your vehicle is a valuable asset. We use only premium products and proven techniques to maintain and enhance its condition.'
    },
    {
      icon: 'ri-vip-crown-line',
      title: 'Perfect for Luxury & Everyday Vehicles',
      description: 'Whether you drive a supercar or a daily commuter, we deliver the same showroom-level results with professional care.'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'One-Time or Regular Maintenance',
      description: 'Need a deep clean before a special event? Or regular upkeep? We customize our service to fit your schedule and needs.'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Trusted by Busy Professionals',
      description: 'Save time and hassle. No need to drive anywhere or wait at a shop—we handle everything while you focus on what matters.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-black via-gray-900 to-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/20 to-transparent"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-yellow-500 uppercase tracking-wider text-sm font-semibold mb-3">
            WHY CHOOSE US
          </p>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Experience the Miami Line Lux
            <span className="text-yellow-500 block mt-2">Difference</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            We're not just another detailing service. We're a fully mobile team dedicated to bringing showroom-level results right to your driveway, with meticulous care and premium products.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl p-8 border border-yellow-500/20 hover:border-yellow-500/40 transition-all duration-300 hover:transform hover:scale-105"
            >
              <div className="w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-yellow-500 text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
              <p className="text-gray-400 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <a
            href="sms:+17863272644"
            className="bg-yellow-500 text-black px-10 py-4 rounded-full text-lg font-bold hover:bg-yellow-400 transition-all inline-flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer shadow-2xl shadow-yellow-500/40"
          >
            <i className="ri-message-3-line text-xl"></i>
            Text Us to Get Started
          </a>
        </div>
      </div>
    </section>
  );
}
